// =========================================================
// * Austin Cloud
// =========================================================

import "@fortawesome/fontawesome-free/css/all.css";
import "react-datetime/css/react-datetime.css";
import "react-toastify/dist/ReactToastify.css";

import "./scss/volt.scss";

import axios from "axios";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import ReactDOM from "react-dom/client";

import { App } from "./components";
import { initOidcConfig } from "./components/auth";
import {
	getCrmApiBase,
	getBlastUiOrigin,
	getCrmUiOrigin,
	isBlast,
	isRedirectEnabled,
	resolvedEndpoints,
} from "./utils";
import { updateSentry } from "./utils/sentry";

updateSentry();

TimeAgo.addDefaultLocale(en);

// Log the resolved endpoints at startup so it's obvious where this build points
// (which env/family/profile each service resolved to).
console.log("[config] resolved endpoints", resolvedEndpoints());

axios.defaults.baseURL = getCrmApiBase();
axios.defaults.headers.post["Content-Type"] = "application/json";

if (isRedirectEnabled() && window.location.origin.includes("igneous.tech")) {
	const redirectURL = new URL(
		window.location.pathname,
		isBlast ? getBlastUiOrigin() : getCrmUiOrigin(),
	);

	window.location.href = redirectURL.href;
} else {
	// Resolve the OIDC config (sameDomain off the real issuer for non-.com hosts)
	// before mounting AuthProvider, so it gets the correct values.
	// Wrapped in an async IIFE because the build target doesn't allow top-level await.
	void (async () => {
		await initOidcConfig();
		const root = ReactDOM.createRoot(
			document.getElementById("root") as HTMLElement,
		);
		root.render(<App />);
		// Tell the index.html boot guard the app mounted, so it stops watching
		// for a failed bundle load and clears the reload counter.
		window.__markBooted?.();
	})();
}
